import React, { useEffect, useRef, useState } from "react";
import { Link } from "gatsby";
import { Container, Row, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
// import ParcheesiVideo from "../../images/services-usa/game_update/why_choose_par.mp4";

function WhyChoose(props) {
  return (
    <section className="p50 why_choose">
      <Container>
        <Row>
          <Col xxl={6} xl={6} lg={6} className="my-auto ">
            <h2>Why Choose TekRevol As Your Game App Development Company?</h2>
            <p>
              When you opt for our game app development from TekRevol, you're
              choosing a team of experts ready to turn your ideas into
              successful game projects.
            </p>
            <p>
              Our dynamic team of skilled developers, designers, and strategists
              works collaboratively to turn your gaming aspirations into
              exceptional realities.
            </p>
            <p>
              Our user-centric approach involves careful attention to detail in
              game design, creating intuitive interfaces that captivate and
              engage players from the first interaction.
            </p>
            <p>
              Moreover, we keep you informed at every stage, from project
              initiation to delivery, ensuring that your vision aligns
              seamlessly with the evolving development process. Our diverse
              portfolio spans various genres, showcasing our versatility and
              ability to create games that cater to a broad spectrum of
              audiences.
            </p>
            <Link to="" className="border_btn">
              Schedule A Free Consultation Session
            </Link>
          </Col>
          <Col xxl={6} xl={6} lg={6} className="my-auto text-center">
            {/* <LazyLoadImage
              alt="case_Study"
              effect="blur"
              src={CaseImg}
              width="100%"
              height="100%"
            /> */}

            <StaticImage
              src="../../images/services-usa/game_update/why_choose_par.webp"
              alt="TekRevol"
              className="banner-image"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={857}
              height={954}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default WhyChoose;
